import { PlDialog } from "./pl--dialog.js"

/**
 * PlSearchDrawer - Custom element for search drawer
 * Extends PlDialog and handles open/close logic
 */
class PlSearchDrawer extends PlDialog {
  connectedCallback() {
    super.connectedCallback()
    this.#attachSearchListeners()
  }

  #attachSearchListeners() {
    // Listen for manual open requests
    document.addEventListener("search:open", () => this.open())

    // Auto-bind all [data-search-open] buttons
    document.querySelectorAll("[data-search-open]").forEach((button) => {
      button.addEventListener("click", () => this.open())
    })

    // Handle close button clicks inside drawer
    const closeButtons = this.querySelectorAll("[data-search-drawer-close]")
    closeButtons.forEach((btn) => {
      btn.addEventListener("click", () => this.close())
    })

    // Focus search input when drawer opens
    this.addEventListener("pl-dialog:opened", () => {
      const searchInput = this.querySelector("pl-search-input")
      if (searchInput) {
        // Small delay to ensure dialog is fully rendered
        setTimeout(() => {
          searchInput.focusInput()
        }, 100)
      }
    })

    // Reset search when drawer closes
    this.addEventListener("pl-dialog:closed", () => {
      const searchInput = this.querySelector("pl-search-input")
      if (searchInput) {
        searchInput.setQuery("")
      }

      // Dispatch reset event for predictive search
      const predictiveSearch = this.querySelector("pl-predictive-search")
      if (predictiveSearch) {
        predictiveSearch.dispatchEvent(
          new CustomEvent("search:reset", {
            bubbles: true,
          })
        )
      }
    })

    // Handle Enter key search - navigate to search page
    this.addEventListener("search:query", (event) => {
      // Only handle searches triggered by Enter key
      if (!event.detail?.fromEnter) {
        return
      }

      const query = event.detail?.query || ""
      const searchUrl = Theme?.routes?.search_url || "/search"

      if (query.trim()) {
        // Navigate to search page with query (same as "View All Results" button)
        const url = new URL(searchUrl, window.location.origin)
        url.searchParams.set("q", query.trim())
        window.location.href = url.toString()
      } else {
        // If query is empty, go to search page without query
        window.location.href = searchUrl
      }
    })
  }
}

if (!customElements.get("pl-search-drawer")) {
  customElements.define("pl-search-drawer", PlSearchDrawer)
}

export { PlSearchDrawer }
